import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material';
import { fromEvent } from 'rxjs';
import { ReferenceAutoComplete } from '../../../../documents/document-reference/reference-auto-complete';
import { BaseAutoCompleteService } from '../../../../services/base-auto-complete.service';
import { IBaseEnumEntity } from '../../../../base/interfaces/IBaseEnumEntity';

@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.css']
})
export class ReferenceComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() queryId: string;
  @Input() controlName: string;
  @Input() displayControlName: string;
  @Input() disabled = false;
  @Input() mandatory = false;
  @Input() allowManual = false;
  @Input() name:string;
  @Input() hint:string;
  @Input() error:string;
  @Input() invalid:boolean = false;
  @Input() id:string;

  @Output() Selected = new EventEmitter<ReferenceAutoComplete>();

  isDisabled = false;
  @ViewChild('refAuto', {static: false}) autocompleteRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger, {static: false}) autocompleteTrigger: MatAutocompleteTrigger;  
  public form: FormGroup;
  public isMultiLine = false;
  public isLoading = false;
  public indicatorDiameter = 18;
  public filteredOptions: ReferenceAutoComplete[];
  private currentValue: string;
  public searchCtrl: FormControl = new FormControl(null);
  private skip = 0;
  private take = 5;   
  constructor(
    private controlContainer: ControlContainer,
    private autoCompleteService: BaseAutoCompleteService    
  ) { }
  ngAfterViewInit(): void {
    const value = this.form.get(this.controlName);
    const incomingId = value.value;
  }

  ngOnInit() {
    this.form = <FormGroup>this.controlContainer.control;    
    const value = this.form.get(this.controlName);
    const incomingId = value.value;    
    this.searchCtrl.setValue(value.value);
    this.searchCtrl.setValidators([Validators.required]);
    value.valueChanges.subscribe((newValue:string) => {
      if(newValue){
        if(!this.displayControlName){
          this.refreshName(newValue);
        }
      }
      this.searchCtrl.setValue(newValue);
    });
    this.isDisabled = value.disabled;
    this.searchCtrl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe( (newValue: string) => {
      this.skip = 0;
      this.onFilter(newValue);
    });    
  }
  ngOnChanges(changes: SimpleChanges) {
  }  
  getDefaultId(name:string){
    let ret = name;
    return ret;
  }  
  get isSelected() {
    const value = this.form.get(this.controlName);
    if(value){
      return value.valid;
    }
    else {
      return false;
    }
  }
  onSelected = (optionValue: IBaseEnumEntity | string) => {  
    const value = this.form.get(this.controlName);
    const displayValue = this.form.get(this.displayControlName);
    let option = null;        
    if (typeof optionValue === 'string' || optionValue instanceof String) {
      if (this.filteredOptions) {
        option = this.filteredOptions.find(f => f.id === optionValue);
      } else {
        option = option;
      }
    }
    this.Selected.emit(option);
    if (option) {
      value.setValue(option.id);
      if(displayValue){
        displayValue.setValue(option.displayName);
      }      
    } else {
      value.setValue(null,{onlySelf:false, emitEvent:true});
      displayValue.setValue(null);
    }
  }
  clearSearchField(evt: MouseEvent) {
    const value = this.form.get(this.controlName);    
    const displayValue = this.form.get(this.displayControlName);
    value.setValue(null);
    this.searchCtrl.setValue(null);
    this.Selected.emit(null);
    if (displayValue) {
      displayValue.setValue(null);
    }    
    evt.stopPropagation();
  }  
  onFilter = (value: string) => {
    this.currentValue = value;
    //this.documentAttribute.referenceInfo.apiPath
    this.isLoading = true;

    this.autoCompleteService.Query(this.queryId,value, this.skip, this.take).subscribe(data => {
      this.isLoading = false;
      let defaultValue:ReferenceAutoComplete = null;      

      if(this.allowManual && this.searchCtrl.value){
        const s = this.searchCtrl.value;
        defaultValue = new ReferenceAutoComplete();
        defaultValue.id = this.getDefaultId(s);
        defaultValue.displayName = s
        defaultValue.name = s
      }

      if (data) {
        let options = [];
        if(defaultValue){
          options.push(defaultValue);
        }
        if(this.skip === 0){
          options = [...options, ...data.payload];
        }
        else {
          options = [...this.filteredOptions, ...data.payload];
        }
        this.filteredOptions = options;        
      }
    }, error => {
      this.isLoading = false;
    });
  }
  onFocusLost = () => {
    if(this.filteredOptions && this.filteredOptions.length === 1){// autoselect if one options
      setTimeout(() => {
        this.onSelected(this.filteredOptions[0].id);
      }, 300);            
    }
  }
  displayFn = (id: string) => {    
    const value = this.form.get(this.controlName);    
    const displayValue = this.form.get(this.displayControlName);
    if (!id || (!value && !displayValue)) {
      return null;
    } else if (value.value === id  && displayValue && displayValue.value) {
      return displayValue.value;
    } else {
      if (this.filteredOptions) {
        const option = this.filteredOptions.find(f => f.id === id);
        if (option) {
          return option.name;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }
  autocompleteScroll() {    
    setTimeout(() => {
      if (
        this.autocompleteRef &&
        this.autocompleteTrigger &&
        this.autocompleteRef.panel
      ) {
        fromEvent(this.autocompleteRef.panel.nativeElement, 'scroll')
          .pipe(
            map(x => this.autocompleteRef.panel.nativeElement.scrollTop),
            takeUntil(this.autocompleteTrigger.panelClosingActions)
          )
          .subscribe(x => {
            if(!this.isLoading){
              const scrollTop = this.autocompleteRef.panel.nativeElement
              .scrollTop;
              const scrollHeight = this.autocompleteRef.panel.nativeElement
                .scrollHeight;
              const elementHeight = this.autocompleteRef.panel.nativeElement
                .clientHeight;
                const atBottom = scrollHeight === scrollTop + elementHeight;
              if (atBottom) {
                this.skip += this.take
                this.onFilter(this.searchCtrl.value);
              }
            }
          });
      }
    });
  }
  onFocus() {
    const serach = this.searchCtrl.value;
    this.skip = 0;
    this.onFilter(serach);
  }
  refreshName(id: string) {
    if(id){
      if(!this.displayControlName){
        this.autoCompleteService.GetItem(this.queryId, id).subscribe(result => {
          if(result){
            if(!this.filteredOptions){
              this.filteredOptions = [];
            }
            if(!this.filteredOptions.find(f => f.id === id)){
              this.filteredOptions.push(result);
            }
            this.searchCtrl.setValue(id);
          }
        });    
      }
    }
  }  
}

